import { PlanningItem } from './types';

export const exportToCSV = (items: PlanningItem[], filename: string) => {
  const headers = ['Datum', 'Tijd', 'Type', 'Titel', 'Doelgroep', 'Kanaal', 'Verantwoordelijke', 'Status', 'Locatie'];
  
  const rows = items
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .map(item => [
      item.date,
      item.time,
      item.type,
      item.title,
      item.targetAudience,
      item.channel || '',
      item.responsible,
      item.status,
      item.location || ''
    ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  return d.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatTime = (time: string): string => {
  const [hours, minutes] = time.split(':');
  return `${hours}:${minutes}`;
};

export const getDaysUntil = (date: string): number => {
  const targetDate = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);
  
  const diffTime = targetDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
};

export const getStatusColor = (status: PlanningItem['status']): string => {
  switch (status) {
    case 'Gepland':
      return '#277CEA'; // Blue
    case 'In voorbereiding':
      return '#FF6B35'; // Orange
    case 'Bevestigd':
      return '#00C853'; // Green
    case 'Afgerond':
      return '#9DA6A8'; // Grey
    case 'Geannuleerd':
      return '#BA1A1A'; // Red
    default:
      return '#323232';
  }
};

export const getTypeIcon = (type: PlanningItem['type']): string => {
  switch (type) {
    case 'mijlpaal':
      return 'M';
    case 'communicatie':
      return 'C';
    case 'bijeenkomst':
      return 'B';
    case 'deadline':
      return 'D';
    default:
      return 'P';
  }
};